import { Vue, Component, Prop, Watch, Inject } from "vue-property-decorator";
import style from "./style.vue";
import { numberToArray, noop } from "@/util";
import GoodsGroup from "@/views/components/goodsGroup";
import bindClassDialog from "@/views/components/newDisplayConfig/bindClassDialog";
import { IPSService } from "@/services/ipsServices";
import editProductGroup from "@/views/components/editProductGroup";

export enum ShowWindowShowType {
	LINE = 1, // 一行2个
	SCROLL, // 横向滚动
	BIG, // 大图
}

export const ShowWindowShowTypeImg = {
	[ShowWindowShowType.LINE]: "https://ssl-picture.tenyun.runsasoft.com/c6586a30-807a-11ea-b75b-775d8e954200",
	[ShowWindowShowType.BIG]: "https://ssl-picture.tenyun.runsasoft.com/ad49ecd0-807a-11ea-ac87-9ba7dcb3330b",
	[ShowWindowShowType.SCROLL]: "https://ssl-picture.tenyun.runsasoft.com/bd4f07a0-807a-11ea-ac87-9ba7dcb3330b",
};

@Component({
	components: { GoodsGroup },
	mixins: [style],
})
export default class ShowWindow extends Vue {
	@Prop({ default: () => {} })
	value: ItemObject;

	@Prop({ default: false })
	disabled: boolean;

	@Inject({ default: 2 })
	mode: number;

	@Prop()
	siteClassList: ItemArray;

	@Prop()
	fromPage: number;

	@Prop({ default: () => [] })
	attrButeList: ItemArray;

	data: ItemObject = {};

	// 展示模式 1 默认模式 fieldType为ShowWindow  2 横排多个 fieldType 为 ShowWindowGroup
	caseWindowType = 1;

	siteId = 0;

	attributeListStore = [];

	@Watch("value", { deep: true, immediate: true })
	watchValue(n, o) {
		this.caseWindowType = n.fieldType === "ShowWindow" ? 1 : 2;
		if (JSON.stringify(n) !== JSON.stringify(o)) {
			this.data = n;
		}
	}

	@Watch("data", { deep: true })
	watchData() {
		this.$emit("input", this.data);
	}

	/**
	 * 拍平树结构方法
	 * @param list
	 * @param result
	 */
	computedTree(list = [], result = []) {
		list.forEach((v) => {
			const item = {
				class_code: "",
				class_name: "",
				value_no: "",
				value_name: "",
			};
			item.class_code = v.attrCode || v.class_code;
			item.class_name = v.attrCode ? v.attrName : this.attrButeList.find((v) => v.attrCode === item.class_code).attrName;
			item.value_no = v.attrCode || v.value_no;
			item.value_name = v.attrName || v.value_name;
			result.push(item);
			if (v.list && v.list.length) {
				this.computedTree(v.list, result);
			}
		});
		return result;
	}

	caseWindowTypeChange(val) {
		switch (val) {
			case 2:
				if (!this.data.desc.caseGroup || !this.data.desc.caseGroup.length) {
					this.data.desc = Object.assign({}, this.data.desc, {
						caseGroup: [
							{
								sgwpId: 0,
								sort: 1,
								caseName: "",
								caseType: 0,
								productCodes: "",
								productSort: 1,
								classList: [],
								productList: [],
							},
						],
					});
				}
				this.data.fieldType = "ShowWindowGroup";
				break;
			case 1:
				this.data.fieldType = "ShowWindow";
				break;
			default:
				break;
		}
	}

	getWinArr(type): number[] {
		if (ShowWindowShowType.LINE === type) {
			return numberToArray(10).map((i) => i * 2);
		} else {
			return numberToArray(10);
		}
	}

	addWindowCase() {
		if (this.data.desc.caseGroup.length < 10) {
			this.data.desc.caseGroup.push({
				sgwpId: 0,
				sort: this.data.desc.caseGroup.length + 1,
				caseName: "",
				caseType: 0,
				productCodes: "",
				productSort: 1,
				classList: [],
				productList: [],
			});
		}
	}

	onDelTab(i) {
		this.$confirm("是否删除该商品橱窗?", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			closeOnClickModal: false,
			type: "warning",
		}).then((result) => {
			if (result === "confirm") {
				this.data.desc.caseGroup.splice(i, 1);
			}
		});
	}

	async mounted() {
		this.siteId = +this.$route.params.siteId;
		this.attributeListStore = this.computedTree(this.attrButeList);
	}

	// 绑定分类
	bindClass(i = -1) {
		let defaultCheckedKeys = [];
		let sortValue = 1;
		let shareImage = "";
		let shareInfo = "";
		if (i === -1) {
			defaultCheckedKeys = this.data.desc.classList.flatMap((v) => v.attrValues.split(","));
			sortValue = this.data.desc.productSort || 1;
			shareImage = this.data.desc.shareImage;
			shareInfo = this.data.desc.shareInfo;
		} else {
			defaultCheckedKeys = this.data.desc.caseGroup[i].classList.flatMap((v) => v.attrValues.split(","));
			sortValue = this.data.desc.caseGroup[i].productSort || 1;
			shareImage = this.data.desc.caseGroup[i].shareImage;
			shareInfo = this.data.desc.caseGroup[i].shareInfo;
		}
		bindClassDialog.open({ defaultCheckedKeys, sortShow: this.mode === 2 && true, footer: this.mode === 2 ? false : true, sortValue, shareImage, shareInfo }).then((result) => {
			let classList = [];
			const attrCode = Array.from(new Set(result?.selectList.map((vl) => vl.class_code)));
			classList = attrCode.map((v) => {
				return {
					attrCode: v,
					attrValues: result?.selectList
						.filter((val) => val.class_code === v)
						.map((vl) => vl.value_no)
						.join(","),
				};
			});
			if (i === -1) {
				this.data.desc.classList = classList;
				this.data.desc.productSort = result.sortValue;
				this.data.desc.shareImage = result.shareImage;
				this.data.desc.shareInfo = result.shareInfo;
			} else {
				this.data.desc.caseGroup[i].classList = classList;
				this.data.desc.caseGroup[i].productSort = result.sortValue;
				this.data.desc.caseGroup[i].shareImage = result.shareImage;
				this.data.desc.caseGroup[i].shareInfo = result.shareInfo;
			}
		}, noop);
	}

	handleCommand(command, i = -1) {
		if (i === -1) {
			this.data.desc.caseType = command;
		} else {
			(this.data.desc as ShowWindowGroupDesc).caseGroup[i].caseType = command;
		}
	}

	openProductGroup(productCodes, i = -1) {
		const productNewList = i === -1 ? this.data.desc.productList ?? [] : (this.data as DisplayShowWindowGroupData).desc.caseGroup[i].productList ?? [];
		const sortValue = i === -1 ? this.data.desc.productSort || null : (this.data as DisplayShowWindowGroupData).desc.caseGroup[i].productSort || null;
		const shareImage = i === -1 ? this.data.desc.shareImage || "" : (this.data as DisplayShowWindowGroupData).desc.caseGroup[i].shareImage || "";
		const shareInfo = i === -1 ? this.data.desc.shareInfo || "" : (this.data as DisplayShowWindowGroupData).desc.caseGroup[i].shareInfo || "";
		editProductGroup
			.open({
				isCloudMall: this.mode === 2 ? 1 : 0,
				empCode: this.$store.state.empCode,
				siteId: this.siteId,
				productCodes: productNewList.length ? "" : productCodes,
				productNewList,
				sortValue,
				shareImage,
				shareInfo,
			})
			.then((result) => {
				if (i === -1) {
					this.data.desc.productCodes = result.list.map((v) => {
						return { c: v.productCode, s: v.sort };
					});
					this.data.desc.productList = result.list;
					this.data.desc.productSort = result.productSort || null;
					this.data.desc.shareImage = result.shareImage || "";
					this.data.desc.shareInfo = result.shareInfo || "";
				} else {
					(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].productCodes = result.list.map((v) => {
						return { c: v.productCode, s: v.sort };
					});
					(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].productList = result.list;
					(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].productSort = result.productSort || null;
					(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].shareImage = result.shareImage || "";
					(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].shareInfo = result.shareInfo || "";
				}
			});
	}

	deleteSelect(type = 1, i = -1) {
		// type=1是商品分类，3是商品组，i=-1是橱窗，其他是橱窗组
		if (i === -1) {
			if (type === 1) {
				this.data.desc.classList = [];
				this.data.desc.productSort = 1;
				this.data.desc.shareImage = "";
				this.data.desc.shareInfo = "";
			} else {
				this.data.desc.productCodes = "";
			}
			this.data.desc.caseType = 0;
		} else {
			if (type === 1) {
				(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].classList = [];
				(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].productSort = 1;
				(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].shareImage = "";
				(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].shareInfo = "";
			} else {
				(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].productCodes = "";
			}
			(this.data as DisplayShowWindowGroupData).desc.caseGroup[i].caseType = 0;
		}
	}

	getProductLength(i = -1) {
		const { caseGroup, productCodes } = this.data.desc;
		if (i === -1) {
			return typeof productCodes === "string" ? (productCodes ? productCodes.split(",").length : 0) : productCodes.length;
		} else {
			return typeof caseGroup[i].productCodes === "string" ? (caseGroup[i].productCodes ? caseGroup[i].productCodes.split(",").length : 0) : caseGroup[i].productCodes.length;
		}
	}

	renderCaseItemContent(h, i) {
		return (
			<el-form-item label="橱窗位名称" key={i} class="case-group-item" prop={`caseGroup[${i}].caseName`} rules={[{ required: true, message: " ", trigger: ["change", "blur"] }]}>
				{!!i && !this.disabled && <i class="el-icon-error delete" onClick={this.onDelTab.bind(this, i)} />}
				<div class="flex relative-position">
					<el-input v-model={this.data.desc.caseGroup[i].caseName} class="flex1" />
				</div>
				<el-form-item class="product-class">
					<el-dropdown placement="top-end" onCommand={(val) => this.handleCommand(val, i)}>
						<span class="scopeSpan no-margin">
							{(this.data.desc as ShowWindowGroupDesc).caseGroup[i].caseType === 3 ? (
								<span onClick={() => this.openProductGroup((this.data.desc as ShowWindowGroupDesc).caseGroup[i].productCodes, i)}>商品组</span>
							) : (this.data.desc as ShowWindowGroupDesc).caseGroup[i].caseType === 1 ? (
								<span onClick={() => this.bindClass(i)}>商品分类</span>
							) : (
								"请选择"
							)}
							<i class="el-icon-caret-bottom r-ml-4" />
						</span>
						<el-dropdown-menu>
							<el-dropdown-item command={3}>
								<span onClick={() => this.openProductGroup((this.data.desc as ShowWindowGroupDesc).caseGroup[i].productCodes, i)}>商品组</span>
							</el-dropdown-item>
							<el-dropdown-item command={1}>
								<span onClick={() => this.bindClass(i)}>商品分类</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					{(this.data.desc as ShowWindowGroupDesc).caseGroup[i].caseType === 1 && (
						<p class="line-height-40 r-pb-14">
							<span>
								已选择
								<span class="r-mx-4">{this.data.desc.caseGroup[i].classList.length}</span>
								个商品分类
							</span>
							<span class="text-red r-ml-24 cursor-pointer" onClick={() => this.deleteSelect(i)}>
								X
							</span>
						</p>
					)}
					{(this.data.desc as ShowWindowGroupDesc).caseGroup[i].caseType === 3 && (
						<p class="line-height-40 r-pb-14">
							<span>
								已选择
								<span class="r-mx-4">{this.getProductLength(i)}</span>
								件商品
							</span>
							<span class="text-red r-ml-24 cursor-pointer" onClick={() => this.deleteSelect(3, i)}>
								X
							</span>
						</p>
					)}
				</el-form-item>
			</el-form-item>
		);
	}

	render(h) {
		return (
			<div class="show-window" key={this.data._sort}>
				<div class="cont">
					<el-form props={{ model: this.data.desc }} label-width="110px" ref="form" label-position={"left"} disabled={this.disabled}>
						<p class="title">展示模式</p>
						<el-radio-group v-model={this.caseWindowType} onChange={this.caseWindowTypeChange.bind(this)} class="r-mx-0 r-mt-8 r-mb-12">
							<el-radio label={1}>默认模式</el-radio>
							<el-radio label={2}>横排多个</el-radio>
						</el-radio-group>
						{this.fromPage !== 6 && this.fromPage !== 8 && (
							<div class="bottom-nav-config">
								<p class="title">基本属性</p>
								{this.caseWindowType === 2 && this.data.desc.caseGroup.length < 10 && !this.disabled && (
									<p class="scopeSpan" onClick={() => this.addWindowCase()}>
										+增加橱窗位
									</p>
								)}
							</div>
						)}
						{this.caseWindowType === 1 && (
							<el-form-item label="橱窗位名称" prop="caseName" rules={[{ required: true, message: " ", trigger: ["change", "blur"] }]}>
								<el-input v-model={this.data.desc.caseName} maxlength="8" />
							</el-form-item>
						)}
						{this.caseWindowType === 1 && (
							<el-form-item label="橱窗标题大小">
								<el-radio-group v-model={this.data.desc.fontSize}>
									<el-radio label={28}>小</el-radio>
									<el-radio label={36}>中</el-radio>
									<el-radio label={44}>大</el-radio>
								</el-radio-group>
							</el-form-item>
						)}
						{this.caseWindowType === 1 && (
							<el-form-item label="橱窗标题样式">
								<el-checkbox-group v-model={this.data.desc.style} class="flex">
									<el-checkbox label={"bold"}>加粗</el-checkbox>
									<el-checkbox label={"center"}>居中对齐</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						)}
						{this.caseWindowType === 2 &&
							this.fromPage !== 6 &&
							this.fromPage !== 8 &&
							this.data.desc.caseGroup.map((v, i) => {
								return (
									<el-form-item label="橱窗位名称" prop={`caseGroup[${i}].caseName`} rules={[{ required: true, message: " ", trigger: ["change", "blur"] }]}>
										<el-input v-model={this.data.desc.caseGroup[i].caseName} style="width: 80%"></el-input>
										&nbsp;&nbsp;&nbsp;&nbsp;
										{!!i && !this.disabled && <i class="iconfont iconlajitong cursor-pointer font-size-14 text-red" onClick={this.onDelTab.bind(this, i)}></i>}
									</el-form-item>
								);
							})}
						<div class="bottom-nav-config">
							<p class="title">展示方式</p>
						</div>
						<el-radio-group
							v-model={this.data.desc.caseStyle}
							class="radio-group window-select"
							onChange={(val) => {
								this.$nextTick(() => {
									switch (val) {
										case ShowWindowShowType.LINE:
											this.data.desc.caseNum = 4;
											break;
										case ShowWindowShowType.BIG:
											this.data.desc.caseNum = 3;
											break;
										case ShowWindowShowType.SCROLL:
											this.data.desc.caseNum = 6;
											break;
									}
								});
							}}>
							<el-radio label={1}>一行两个</el-radio>
							<el-radio label={2}>横向滚动</el-radio>
							<el-radio label={3}>大图</el-radio>
						</el-radio-group>

						<div class="sketch-img">
							{Object.keys(ShowWindowShowTypeImg).map((v, i) => {
								return (
									<img
										src={ShowWindowShowTypeImg[v]}
										alt=""
										onClick={() => {
											this.data.desc.caseStyle = +v;
										}}
									/>
								);
							})}
						</div>
					</el-form>
					<el-form props={{ model: this.data.desc }} ref="formb" disabled={this.disabled}>
						<div class="bottom-nav-config r-mt-10">
							<p class="title">内容样式</p>
						</div>
						<el-form-item label="显示元素数量" prop="caseNum">
							<el-select v-model={this.data.desc.caseNum} class="wid-40">
								{this.getWinArr(this.data.desc.caseStyle).map((i) => {
									return (
										<el-option label={i} value={i}>
											{i}
										</el-option>
									);
								})}
							</el-select>
							&nbsp;&nbsp;个
						</el-form-item>
						{this.data.fieldType === "ShowWindowGroup" && (
							<el-form-item label="查看更多按钮">
								<el-radio-group v-model={this.data.desc.isShowMore}>
									<el-radio label={1}>显示</el-radio>
									<el-radio label={0}>不显示</el-radio>
								</el-radio-group>
							</el-form-item>
						)}
						{(this.fromPage === 6 || this.fromPage === 8) && this.caseWindowType === 1 && <p class="title">商品管理</p>}
						{(this.fromPage === 6 || this.fromPage === 8) && this.caseWindowType === 1 && (
							<el-form-item class="product-class">
								<el-dropdown placement="top-end" onCommand={(val) => this.handleCommand(val)}>
									<span class="scopeSpan no-margin">
										{this.data.desc.caseType === 3 ? <span onClick={() => this.openProductGroup(this.data.desc.productCodes)}>商品组</span> : this.data.desc.caseType === 1 ? <span onClick={() => this.bindClass()}>商品分类</span> : "请选择"}
										<i class="el-icon-caret-bottom r-ml-4" />
									</span>
									<el-dropdown-menu>
										<el-dropdown-item command={3}>
											<span onClick={() => this.openProductGroup(this.data.desc.productCodes)}>商品组</span>
										</el-dropdown-item>
										<el-dropdown-item command={1}>
											<span onClick={() => this.bindClass()}>商品分类</span>
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								{this.data.desc.caseType === 1 && (
									<p class="line-height-40 r-pb-14">
										<span>
											已选择
											<span class="r-mx-4">{this.data.desc.classList.length}</span>
											个商品分类
										</span>
										<span class="text-red r-ml-24 cursor-pointer" onClick={() => this.deleteSelect()}>
											X
										</span>
									</p>
								)}
								{this.data.desc.caseType === 3 && (
									<p class="line-height-40 r-pb-14">
										<span>
											已选择
											<span class="r-mx-4">{this.getProductLength()}</span>
											件商品
										</span>
										<span class="text-red r-ml-24 cursor-pointer" onClick={() => this.deleteSelect(3)}>
											X
										</span>
									</p>
								)}
								{/* {this.data.desc.caseType === 3 && this.renderAddProductGroup(h, this.data.desc.productCodes)}
                {this.data.desc.caseType === 1 && this.renderAddClass(h, -1)} */}
							</el-form-item>
						)}
						{(this.fromPage === 6 || this.fromPage === 8) && this.caseWindowType === 2 && (
							<el-form-item>
								<div class="bottom-nav-config">
									<p class="title">商品管理</p>
									{this.data.desc.caseGroup.length < 10 && !this.disabled && (
										<p class="scopeSpan" onClick={() => this.addWindowCase()}>
											+增加橱窗位
										</p>
									)}
								</div>
							</el-form-item>
						)}
						{(this.fromPage === 6 || this.fromPage === 8) &&
							this.caseWindowType === 2 &&
							this.data.desc.caseGroup.map((v, i) => {
								return this.renderCaseItemContent(h, i);
							})}
					</el-form>
				</div>
			</div>
		);
	}
}
